import Vue from 'vue';
import moment from 'moment';

const success = (response, context) => {
    context.logs = response.data.results;
};

const failed = (error, context) => {
  // toastr.error(error.data.msg);
};

export default (context, rentalId, bookingId) => {
    return Vue.$http.get(`/events-logger/${rentalId ? rentalId + (bookingId ? '/' + bookingId : '') : ''}`)
        .then((response) => {
            if (response && response.status === 200) {
            success(response, context);
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};


// WEBPACK FOOTER //
// ./src/app/services/event-logger/get.js